import styled from 'styled-components';

export const Content = styled.div`
  background-color: white;
  padding: 12px;
  border: 1px solid #dfdfdf;
  margin-top: 12px;
`;
